
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "EditorEmptyState2478527034",
      {"classes":{"root":"EditorEmptyState2478527034__root","illustration":"EditorEmptyState2478527034__illustration","header":"EditorEmptyState2478527034__header","body":"EditorEmptyState2478527034__body"},"vars":{},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  